import React from 'react';
import { Badge, Text, Tooltip, InlineLink } from '@fullstory/components';
import { FormattedMessage, useIntl } from 'react-intl';
import css from './index.module.scss';
import { useFlags } from '@fullstory/react-hooks';

const learnMoreLink = (
  <InlineLink
    href="https://help.fullstory.com/hc/en-us/articles/360052331173-Pages-in-Fullstory#01FE48A345M5CG2WYGSHSWE7K3"
    newTab
    // Prevents clicking through to the row in the pages table.
    onClick={e => e.stopPropagation()}
  >
    <FormattedMessage defaultMessage="Learn more" id="TdTXXf" />
  </InlineLink>
);

export const MLPill = () => {
  const intl = useIntl();
  const mlText = intl.formatMessage({
    defaultMessage: 'ML',
    id: 'fG2g6y',
    description: 'Machine Learning',
  });
  const newFSTAColors = useFlags().featureFlags().AppNewFstaColors;

  return (
    <Tooltip
      data-component="MLPill"
      placement="right"
      variant="light"
      tooltipContent={
        <Text appearance="bodySmall">
          <FormattedMessage
            defaultMessage="Fullstory groups similar pages using machine learning."
            id="PtjPmD"
          />{' '}
          {learnMoreLink}
        </Text>
      }
      className={css.tooltip}
    >
      <Badge variant={newFSTAColors ? 'intelligence-border' : 'intelligence'}>{mlText}</Badge>
    </Tooltip>
  );
};
